<template>
  <div class="events-list-wrap roster-list-wrap">
    <div class="container">
      <div class="roster-content-wrap events-content-wrap">
        <div class="main-heading text-center">
          <h1>Latest Roster</h1>
        </div>
        <div style="width: 100%" v-if="rosterListLimited.length === 0">
          <p class="text-center no-data" v-if="userBelongsToClub">
            Please upgrade your profile to create/view rosters
          </p>
          <p class="text-center no-data" v-else>No Data Available !</p>
        </div>
        <div class="roster-wrap" v-else>
          <a-row :gutter="[24, 32]">
            <a-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="8"
              :xl="6"
              v-for="(roster, index) in rosterListLimited"
              :key="index"
            >
              <RosterCard :active="showActive" :key="index" :roster="roster" />
            </a-col>
          </a-row>
        </div>
        <div class="button-wrap text-center" style="margin-top: 20px;">
          <button
            @click="handleViewAll"
            type="button"
            class="btn btn-default text-center"
            v-if="!club.coachDowngraded && rosterListLimited.length > 0"
          >
            View All
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RosterCard from "@/views/roster/card";
import { mapGetters } from "vuex";

const STORE_KEY = "rosterStore";
const CLUB_STORE_KEY = "clubStore";

export default {
  name: "Roster",
  components: {
    RosterCard
  },
  data() {
    return {
      showActive: true
    };
  },
  computed: {
    ...mapGetters({
      rosterListLimited: `${STORE_KEY}/rosterListLimited`,
      rosterListLoading: `${STORE_KEY}/rosterListLoading`,
      club: `${CLUB_STORE_KEY}/club`
    }),
    clubId() {
      return this.$route.params.id || localStorage["club-id"];
    },
    userBelongsToClub() {
      return (
        !this.$route.params.id ||
        this.$route.params.id === localStorage["club-id"]
      );
    }
  },
  methods: {
    setActive(val) {
      this.showActive = val;
      this.getRoster();
    },
    handleViewAll() {
      this.$emit("view-all");
    },
    getRoster() {
      this.$store.dispatch(`${STORE_KEY}/getRosterListLimited`, {
        clubId: this.clubId,
        isActive: this.showActive,
        limit: 4,
        page: 1
      });
    }
  }
};
</script>

<style lang="scss">
.roster-list-wrap {
  .main-heading {
    h1 {
      border: none;
    }
  }
  .roster-content-wrap {
    padding-top: 60px;
    .roster-wrap {
      .ant-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }
}
.active {
  color: #d73228 !important;
}
</style>
